import type { Locales } from '@i18n/i18n-types';

import deImg from './images/de.png';
import enImg from './images/en.png';
import esImg from './images/es.png';
import frImg from './images/fr.png';
import hiImg from './images/hi.png';
import itImg from './images/it.png';
import ptImg from './images/pt.png';
import ruImg from './images/ru.png';
import trImg from './images/tr.png';

export const FLAGS: Record<Locales, string> = {
    en: enImg,
    fr: frImg,
    de: deImg,
    it: itImg,
    ru: ruImg,
    pt: ptImg,
    hi: hiImg,
    tr: trImg,
    es: esImg,
};

export const NAMES: Record<Locales, string> = {
    en: 'English',
    fr: 'Français',
    es: 'Español',
    de: 'Deutsch',
    ru: 'Русский',
    tr: 'Türk',
    hi: 'हिन्दी',
    it: 'Italiano',
    pt: 'Português',
};
